// 今夜の掟: the rules of the night. The date picks one or two; they change how
// the pools play, so every night is a slightly different game. Everything here
// is deterministic from the night's seed.
import { rand } from './rand.js';

// weight: how often it is picked; tides: tides it prefers (picked more often there);
// clash: rules it never pairs with.
export const RULES = {
  current:   { weight: 10, tides: ['oshio', 'nakashio'], clash: ['calm'] },
  vortex:    { weight: 8, tides: ['oshio'], clash: [] },
  driftwood: { weight: 9, tides: [], clash: [] },
  rain:      { weight: 7, tides: ['koshio'], clash: ['bloom'] },
  fog:       { weight: 6, tides: ['nagashio'], clash: [] },
  bloom:     { weight: 7, tides: ['wakashio'], clash: ['rain'] },
  calm:      { weight: 7, tides: ['koshio', 'nagashio'], clash: ['current'] },
  rival:     { weight: 7, tides: ['nakashio'], clash: [] },
  pearls:    { weight: 9, tides: ['oshio'], clash: [] },
  swift:     { weight: 6, tides: ['wakashio'], clash: [] },
  kelp:      { weight: 6, tides: ['nagashio'], clash: [] },
};

// The 8 compass directions as integer vectors (for currents).
export const DIRS8 = [[1000, 0], [707, 707], [0, 1000], [-707, 707], [-1000, 0], [-707, -707], [0, -1000], [707, -707]];

export function pickRules(seed, tide) {
  const r = rand((seed ^ 0x5eed1e5) >>> 0);
  const weighted = id => RULES[id].weight * (RULES[id].tides.includes(tide) ? 3 : 1);
  const choose = exclude => {
    const ids = Object.keys(RULES).filter(id => !exclude.includes(id));
    const total = ids.reduce((n, id) => n + weighted(id), 0);
    let x = r.below(total);
    for (const id of ids) { x -= weighted(id); if (x < 0) return id; }
    return ids[0];
  };
  const first = choose([]);
  const rules = [first];
  // Two rules on about a third of nights.
  if (r.below(100) < 35) rules.push(choose([first, ...RULES[first].clash, ...Object.keys(RULES).filter(id => RULES[id].clash.includes(first))]));
  const params = { currentDir: DIRS8[r.below(8)] };
  return { rules, params };
}
